import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CartIcon = ({tintColor = '#001533', ...props}) => {
  return (
    <Svg
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.53 4H6.114L4.54 1.18a1 1 0 00-.873-.513h-2a1 1 0 000 2h1.412L4.632 5.45l3.582 7.924.003.008.316.698-3.596 3.836a1 1 0 00.616 1.677l3.278.375c4.1.468 8.239.468 12.338 0l3.278-.375a1 1 0 00-.227-1.987l-3.278.375a52.33 52.33 0 01-11.884 0l-1.3-.149 2.638-2.815a.992.992 0 00.071-.085l1.004.131c1.407.183 2.829.219 4.242.107a12.386 12.386 0 008.489-4.358l.77-.913a.994.994 0 00.073-.097l1.436-2.189C27.5 6.062 26.386 4 24.531 4zm-13.988 8.925a.646.646 0 01-.504-.37l-.002-.004L7.076 6H24.53c.265 0 .424.294.279.516l-1.403 2.139-.732.867a10.386 10.386 0 01-7.118 3.654c-1.276.101-2.558.069-3.827-.096l-1.187-.155z"
        fill={tintColor}
      />
      <Path
        d="M7.667 21.666a2 2 0 100 4 2 2 0 000-4zM20.333 23.666a2 2 0 114 0 2 2 0 01-4 0z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default CartIcon;
